import React, { useState } from "react";
import { Button } from "./ui/button";
import { ShieldCheck, X } from "lucide-react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-sm border-t border-border shadow-2xl">
      <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3">
        <div className="flex items-start gap-2.5 text-sm">
          <ShieldCheck className="h-4 w-4 text-primary shrink-0 mt-0.5" />
          <div>
            <p className="text-foreground text-xs leading-relaxed">
              Les informations recueillies via ce formulaire sont exclusivement
              destinées à l'association dans le cadre de son organisation. Seuls
              les membres du bureau y ont accès.
            </p>
            <p className="text-muted-foreground text-xs mt-0.5">
              Vos données personnelles sont traitées de manière confidentielle et sécurisée.
            </p>
          </div>
        </div>
        <Button
          onClick={() => setIsVisible(false)}
          variant="outline"
          size="sm"
          className="shrink-0 gap-1.5"
        >
          <X className="h-3 w-3" />
          J'ai compris
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
